import management from './management';

const menuListByManager = {
  items: [management],
};

export default menuListByManager;
